var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#CBC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6684 14.3016L14.3016 41.6684L12.9038 43.0662L25.7472 55.9096C26.4904 55.9688 27.2414 56 28 56C43.4639 56 56 43.4639 56 28C56 27.2414 55.9688 26.4904 55.9096 25.747L43.0663 12.9037L41.6684 14.3016Z",
    fill: "#A5A3F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67188 28C6.67188 39.7793 16.2208 49.3281 28 49.3281L31.0509 28L28 6.67188C16.2208 6.67188 6.67188 16.2207 6.67188 28Z",
    fill: "#555A65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3281 28C49.3281 16.2207 39.7793 6.67188 28 6.67188V49.3281C39.7793 49.3281 49.3281 39.7793 49.3281 28Z",
    fill: "#333940"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40625 28C9.40625 38.269 17.731 46.5938 28 46.5938L30.7716 28L28 9.40625C17.731 9.40625 9.40625 17.731 9.40625 28Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5938 28C46.5938 17.731 38.269 9.40625 28 9.40625V46.5938C38.269 46.5938 46.5938 38.269 46.5938 28Z",
    fill: "#E9EDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0394 34.9606C19.1173 33.0385 18.1562 30.5192 18.1562 28L15.3009 26.0847L11.5938 28C11.5938 32.1987 13.1955 36.3975 16.399 39.601L21.0394 34.9606Z",
    fill: "#95CC29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0394 21.0394L20.0889 17.6513L16.399 16.399C13.1955 19.6025 11.5938 23.8013 11.5938 28H18.1562C18.1562 25.4808 19.1173 22.9615 21.0394 21.0394Z",
    fill: "#B1E153"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3989 16.399L21.0393 21.0394C22.9614 19.1173 25.4807 18.1562 27.9999 18.1562L30.1571 15.2497L27.9999 11.5938C23.8012 11.5938 19.6024 13.1955 16.3989 16.399Z",
    fill: "#D8FB94"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.601 16.399C36.3975 13.1955 32.1987 11.5938 28 11.5938V18.1562C30.5192 18.1562 33.0385 19.1173 34.9606 21.0394L38.3115 20.1087L39.601 16.399Z",
    fill: "#F29F8E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.601 16.399L34.9607 21.0394C36.8827 22.9615 37.8438 25.4808 37.8438 28L41.1042 29.2683L44.4063 28C44.4063 23.8013 42.8045 19.6025 39.601 16.399Z",
    fill: "#FF6A4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.601 39.601C42.8045 36.3975 44.4063 32.1987 44.4063 28H37.8438C37.8438 30.5192 36.8827 33.0385 34.9607 34.9606L39.601 39.601Z",
    fill: "#FA455C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9823 28.9824C29.8013 28.1634 29.7115 26.8105 28.7915 26.1069L17.3813 17.3815L26.1067 28.7916C26.8103 29.7116 28.1632 29.8014 28.9823 28.9824Z",
    fill: "#555A65"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeights);
export default __webpack_public_path__ + "static/media/weights.785b6c6dbdf69f73db505a4ba5665bbc.svg";
export { ForwardRef as ReactComponent };